import {NgModule} from "@angular/core";
import {SharedModule} from "../shared.module";
import {MasterDataComponent} from "./masterdata.component";

@NgModule({
    imports: [
        SharedModule
    ],
    declarations: [
        MasterDataComponent
    ]
})
export class MasterDataModule {

}